import Swiper from 'swiper/swiper-bundle.min';
export default (function () {
  //team-block__item active
  $('.team-block__item').click(function () {
    if ($(window).innerWidth() < 768) {
      $(this).toggleClass('active');
    }
  }); //team-block__item active
  //ellipsis

  $('.team-block__item .description .text').ellipsis({
    lines: 10
  });
  $(window).on('load', function () {
    $('.team-block__item .description .text').ellipsis({
      lines: 10
    });
  });
  $(document).ajaxComplete(function () {
    $('.team-block__item .description .text').ellipsis({
      lines: 10
    });
  });
  $(window).resize(function () {
    $('.team-block__item .description .text').ellipsis({
      lines: 10
    });
  }); //ellipsis
});